<template>
  <Dialog v-model="show" :title="$t('Historial')">
    <template v-slot:content>
      <v-container fluid  v-if="cliente">
        <v-tabs class="elevation-2" v-if="active_tab" v-model="active_tab" grow
                show-arrows prev-icon="mdi-arrow-left-circle" next-icon="mdi-arrow-right-circle">

          <!-- Apartado de tabs -->

          <!-- Citas -->
          <v-tab href="#tab-citas">
            <span class="tab_title">{{ $t("Citas") }}</span>
          </v-tab>

          <!-- Ventas -->
          <v-tab href="#tab-ventas">
            <span class="tab_title">{{ $t("Ventas") }}</span>
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="active_tab" class="elevation-2" touchless>

          <v-tab-item v-if="show_citas_cliente" value="tab-citas" class="pa-4 grey lighten-5">
            <CitasCliente v-if="id_cliente && active_tab==='tab-citas'" ref="citas_cliente" :id_cliente="id_cliente"/>
          </v-tab-item>
          <v-tab-item v-if="!show_citas_cliente" value="tab-citas" class="pa-4 grey lighten-5">
            <div class="container_info_azul">
              <span>{{ $t('No tienes permiso para ver las citas previas del cliente.') }}</span>
            </div>
          </v-tab-item>

          <v-tab-item v-if="show_ventas_cliente" value="tab-ventas" class="pa-4 grey lighten-5">
            <VentasCliente v-if="id_cliente && active_tab==='tab-ventas'" ref="ventas_cliente" :cliente="cliente"
                           :allow_edit_puntos="false"
            />
          </v-tab-item>
          <v-tab-item v-if="!show_ventas_cliente" value="tab-ventas" class="pa-4 grey lighten-5">
            <div class="container_info_azul">
              <span>{{ $t('No tienes permiso para ver las ventas previas del cliente.') }}</span>
            </div>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </template>
  </Dialog>
</template>


<script>

export default {
  name: 'DialogHistorial',
  data() {
    return {
      active_tab: "tab-citas",
    }
  },
  props: {
    id_cliente: {
      required: true
    },
    cliente: {
      required: true
    }
  },

  computed: {
    show: {
      get() {
        return this.cliente
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    show_ventas_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_ventas_cliente")) {
          return true
        }
      }
      return false
    },
    show_citas_cliente(){
      if (this.$store.state.auth.user.tipo_empleado === 'admin') {
        return true
      } else {
        if (this.$store.getters['auth/has_permission']("ver_citas_cliente")) {
          return true
        }
      }
      return false
    },
  },

  components: {
    CitasCliente: () => import('@/views/Agenda/components/CitasCliente'),
    VentasCliente: () => import('@/views/Ventas/VentasCliente'),
  }
}
</script>
